document.addEventListener('DOMContentLoaded',function(){
  var main=document.getElementById('M15MainImage');
  document.querySelectorAll('.product-thumb').forEach(function(button){
    button.addEventListener('click',function(){
      if(!main)return;
      main.src=button.dataset.image;
      document.querySelectorAll('.product-thumb').forEach(function(item){item.classList.remove('is-active')});
      button.classList.add('is-active');
    });
  });
});